module.exports = __webpack_public_path__ + "static/media/opportunities-main-image.52ee77cd.png";